import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import CircularProgress from "material-ui/CircularProgress";

export default ( ( {
  message, previousMessage, isSameDay,
} ) => {
  const showCurrentUserImg = message.agent && (
    ( message.agent.id !== _.get( previousMessage, 'agent.id' ) ) || !isSameDay()
  );

  return (
    <div
      className={classnames( {
        'chat-messages-message-right mr-3': message.agent,
        'chat-messages-message-left': !message.agent,
      } )}
    >
      <div className="chat-messages-message-container">
        <div className="row no-gutters align-items-center">
          <div className="col order-1 order-sm-0">
            {showCurrentUserImg
              ? (
                <div className="row no-gutters">
                  <div className="col p-0 chat-messages-message-username text-right">
                    <span>
                      {message.agent.name}
                    </span>
                  </div>
                </div>
              ) : null}
            <div
              key={message.id}
              className="chat-messages-message-content"
            >
              {( !!message.webPathFileName )
              && (
                <div className="col-xs-12 chat-messages-message-image">
                  <a href={message.webPathFileName} target="_blank">
                    {_.startsWith( message.mimeType, 'image/' ) ?
                      <img
                        alt="..."
                        src={message.webPathFileName}
                      />
                      : <i className={classnames( 'fa fa-file-archive-o fa-2x', {
                        'color-white': !!message.agent
                      } )}/>}
                  </a>
                </div>
              )}
              {!!message.body
              && (
                <div className="col-xs-12 chat-messages-message-text">
                  <span>{message.body}</span>
                </div>
              )}
              <div className="col-xs-12 chat-messages-message-time">
                <span>{moment( Number( `${message.createdAt}000` ) ).format( 'h:mm A' )}</span>
                {message.type === 'file' && !message.id && message.status !== 'ERROR' &&
                <span className="ml-2"><CircularProgress color="white" size={20} thickness={3}/></span>}
                {message.status === 'ERROR' &&
                <i className="fa fa-exclamation-circle text-danger ml-2" style={{ fontSize: '18px' }}/>}
                {/*
                {message.status === 'SENT' && <i className="fa fa-check text-success ml-1" />}
                 */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChatDetail/Message/index.js